import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import * as types from '../store/mutation-types'

// 首页相关
//import Home from '@/pages/home'

// 用户相关

import User from '@/pages/user/index.vue'
import UserLogin from '@/pages/user/Login.vue'
import UserRegister from '@/pages/user/Register.vue'
import UserProfile from '@/pages/user/Profile.vue'
import OrderList from '@/pages/user/orderList.vue'
import AddressList from '@/pages/user/addressList.vue'
import InvoiceList from '@/pages/user/invoiceList.vue'
import OrderDetail from '@/pages/user/OrderDetail.vue'
import CollectProductList from '@/pages/user/CollectProductList.vue'
import CollectSupplierList from '@/pages/user/CollectSupplierList.vue'

// 密码相关
import PasswordReset from '@/pages/user/password/Reset.vue'
import PasswordForget from '@/pages/user/password/Forget.vue'
import PasswordVerify from '@/pages/user/password/Verify.vue'

// OAuth相关
import OAuthKey from '@/pages/oauth/key.vue'
// 订单
import Order from '@/pages/order'
import Payment from '@/pages/order/payment.vue'
import Paysuccess from '@/pages/order/paysuccess.vue'
import Wechat from '@/pages/order/wechat.vue'
import Alipay from '@/pages/order/alipay.vue'

//商品
import Goods from '@/pages/goods'

import Search from '@/pages/search'
import Billboard from '@/pages/search/billboard.vue'
import MainCate from '@/pages/search/mainCate.vue'
//商品详情
import GoodsDetails from '@/pages/goods/goodsDetails.vue'
//待审商品详情
import WaitAuditGoodsDetails from '@/pages/goods/waitAuditGoodsDetails.vue'

//首页
import HomePage from '@/pages/homePage'

//购物车
 import Cart from '@/pages/cart'

//结算
import CheckOut from '@/pages/checkout'

//底部链接
import BottomLink from '@/pages/bottomLink/index.vue'
import BottomLinkDetail from '@/pages/bottomLink/detail.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '/loginResult',
      component: () => import('@/pages/user/loginResult.vue'),
      hidden: true,
    },
    {
      path: '/',
      component: HomePage,
      name: 'home',
      redirect: '/home',
      children: [
        {path: 'home', component: HomePage}
      ]
    },
    { 
      path: '/goodsDetails', name: 'goodsDetails',component: GoodsDetails
    },
    { 
      path: '/waitAuditGoodsDetails', name: 'waitAuditGoodsDetails',component: WaitAuditGoodsDetails
    },
    { 
      path: '/search', name: 'search',component: Search
    },
    { 
      path: '/billboard', name: 'billboard',component: Billboard
    },
    { 
      path: '/mainCate', name: 'mainCate',component: MainCate
    },
    { 
      path: '/home', name: 'home',component: HomePage
    },
    {
      path: '/cart', name: 'cart', component: Cart, meta: {requiresAuth: true}
    },
    {
      path: '/checkout', name: 'checkout', component: CheckOut, meta: {requiresAuth: true}
    },
    { 
      path: '/user/login', name: 'userLogin', component: UserLogin
    }, 
    {
      path: '/user/register', name: 'userRegister', component: UserRegister
    }, 
    {
      path: '/user/password/reset', name: 'passwordReset', component: PasswordReset, meta: { requiresAuth: true}
    },
    {
      path: '/user/password/forget', name: 'passwordForget', component: PasswordForget
    }, 
    {
      path: '/user/password/reset/:token', name: 'passwordVerify', component: PasswordVerify
    }, 
    {
      path: '/auth/key', name: 'authKey', component: OAuthKey
    }, 
    {
      path: '/user',
      name: 'user',
      component: User,
      redirect: '/user/orderList',
      children: [
        {path: 'orderList', name: 'orderList', component: OrderList},
        {path: 'orderDetail', name: 'orderDetail', component: OrderDetail},
        {path: 'profile', name: 'userProfile', component: UserProfile},
        {path: 'addressList', name: 'addressList', component: AddressList},
        {path: 'invoiceList', name: 'invoiceList', component: InvoiceList},
        {path: 'updatePassword', name: 'updatePassword', component: PasswordReset},
        {path: 'collectProductList', name: 'collectProductList', component: CollectProductList},
        {path: 'collectSupplierList', name: 'collectSupplierList', component: CollectSupplierList},
      ]
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      children: [
        {path: 'paysuccess', name: 'paysuccess', component: Paysuccess},
        {path: 'payment', name: 'payment', component: Payment},
         {path: 'alipay', name: 'alipay', component: Alipay},
         {path: 'wechat', name: 'wechat', component: Wechat},
      ]
    },
    {
      path: '/bottomLink',
      name: 'bottomLink',
      component: BottomLink,
      redirect: '/bottomLink/detail',
      children: [
        {path: 'detail', name: 'detail', component: BottomLinkDetail},      
      ]
    },
  ]
})

// 导航钩子
router.beforeEach((to, from, next) => {
  // 检查登录状态
  store.commit(types.CHECKOUT_LOGIN_STATUS)
  if (to.matched.some(record => record.meta.requiresAuth)) { // 判断该路由是否需要登录权限
    if (window.localStorage.ACCESS_TOKEN) { // 如果本地存在 access_token，则继续导航
      next()
    } else {
      next({
        path: '/user/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js